var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMandi1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7186 4.57883L18.8809 0.755939C18.6621 0.280777 18.1808 0 17.6557 0H7.48254C6.95748 0 6.49804 0.302376 6.27926 0.755939L4.44153 4.55723C4.22275 5.05399 4.5728 5.59395 5.11974 5.59395H6.01673V8.53132H12.952C13.6083 8.53132 14.2209 8.83369 14.6366 9.33045C15.0523 9.84881 15.1835 10.4968 15.0304 11.1447L14.199 14.5356H18.0495C18.6621 14.5356 19.1434 14.0389 19.1434 13.4557V5.61555H20.0404C20.5873 5.61555 20.9374 5.05399 20.7186 4.57883Z",
    fill: "#152424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9517 9.97843H3.63171L3.30355 8.66094C3.21604 8.35856 2.9535 8.14258 2.62534 8.14258H0.70009C0.306289 8.14258 0 8.44495 0 8.83372C0 9.22249 0.306289 9.52487 0.70009 9.52487H2.07839L3.80674 16.3283C3.89425 16.6307 4.15678 16.8467 4.48495 16.8467H11.6171C11.9453 16.8467 12.2078 16.6307 12.2953 16.3283L13.6299 10.864C13.6736 10.6696 13.6299 10.432 13.4986 10.2808C13.3673 10.0648 13.1704 9.97843 12.9517 9.97843Z",
    fill: "#152424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44781 20.0001C6.12445 20.0001 6.67297 19.4585 6.67297 18.7906C6.67297 18.1226 6.12445 17.5811 5.44781 17.5811C4.77118 17.5811 4.22266 18.1226 4.22266 18.7906C4.22266 19.4585 4.77118 20.0001 5.44781 20.0001Z",
    fill: "#152424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3043 20.0001C10.9809 20.0001 11.5294 19.4585 11.5294 18.7906C11.5294 18.1226 10.9809 17.5811 10.3043 17.5811C9.62762 17.5811 9.0791 18.1226 9.0791 18.7906C9.0791 19.4585 9.62762 20.0001 10.3043 20.0001Z",
    fill: "#152424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandi1);
export default __webpack_public_path__ + "static/media/mandi (1).b2f5d2bbdf308b77150362abc5dc6d93.svg";
export { ForwardRef as ReactComponent };